import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: "/",
    name: "gen",
    redirect: "oauth",
    component: () => import("../views/orks/OutHee.vue"),

    
    children: [
      {
        path: "/emps",
        name: "emps",
        component: () => import("../views/orks/OrksEmp.vue"),
      },

      /* 新增产品列表 */
      {
        path: "/addproductlist",
        name: "addproductlist",
        component: () => import("../views/orks/AddProductList.vue"),
      },

      {
        path: "/type",
        name: "type",
        component: () => import("../views/orks/ProductClassify.vue"),
      },
      {
        path: "/solutionlist",
        name: "solutionlist",
        component: () => import("../views/solution/SchemeList.vue"),
      },

      {
        path: "/addschemelist",
        name: "addschemelist",
        component: () => import("../views/solution/AddSchemeList.vue"),
      },

      {
        path: "/solutionclassify",
        name: "solutionclassify",
        component: () => import("../views/solution/SchemeClassify.vue"),
      },
      {
        path: "/customercaselist",
        name: "customercaselist",
        component: () => import("../views/customer/CustomerCaseList.vue"),
      },

      /* 新增客户列表 */
      {
        path: "/addcustomercaselist",
        name: "addcustomercaselist",
        component: () => import("../views/customer/AddCustomerCaseList.vue"),
      },

      {
        path: "/customercaseclassify",
        name: "customercaseclassify",
        component: () => import("../views/customer/CustomerCaseClassify.vue"),
      },
      

      {
        path: "/customerlist",
        name: "customerlist",
        component: () => import("../views/customer/CustomerList.vue"),
      },
       {
        path: "/subOrg",
        name: "subOrg",
        component: () => import("../views/orks/suborg/subOrg.vue"),
      },
{
        path: "/suborgtype",
        name: "suborgtype",
        component: () => import("../views/orks/suborg/subOrgType.vue"),
      },
        {
        path: "/JoinUs",
        name: "JoinUs",
        component: () => import("../views/orks/joinUs/joinUs.vue"),
      },

       {
        path: "/VideoCenter",
        name: "VideoCenter",
        component: () => import("../views/orks/videoCenter/videoCenter.vue"),
      },

      /* 新增客户列表 */
      // {
      //   path: "/addcustomerlist",
      //   name: "addcustomerlist",
      //   component: () => import("../views/customer/AddCustomerList.vue"),
      // },

      {
        path: "/customerclassify",
        name: "customerclassify",
        component: () => import("../views/customer/CustomerClassify.vue"),
      },

      {
        path: "/newslist",
        name: "newslist",
        component: () => import("../views/news/NewsList.vue"),
      },
      {
        path: "/addnewslist",
        name: "addnewslist",
        component: () => import("../views/news/AddNewsList.vue"), // 子路由的组件
      },
      {
        path: "/newsclassify",
        name: "newsclassify",
        component: () => import("../views/news/NewsClassify.vue"),
      },

      {
        path: "/site",
        name: "site",
        component: () => import("../views/SystemAdmin/WebSite.vue"),
      },

      {
        path: "/icp",
        name: "icp",
        component: () => import("../views/SystemAdmin/ICP.vue"),
      },

      {
        path: "/cer",
        name: "cer",
        component: () =>
          import("../views/SystemAdmin/CertificationInformation.vue"),
      },

      {
        path: "/nav",
        name: "nav",
        component: () => import("../views/SystemAdmin/NavigationBar.vue"),
      },

      {
        path: "/down",
        name: "down",
        component: () => import("../views/SystemAdmin/DownBar.vue"),
      },

      /* 首页滑轮滚动页*/
      {
        path: "/rollingbanner",
        name: "rollingbanner",
        component: () => import("../views/banner/RollingBanner.vue"),
      },

      {
        path: "/coreservices",
        name: "coreservices",
        component: () => import("../views/banner/CoreServices.vue"),
      },

      {
        path: "/oauth",
        name: "oauth",
        component: () => import("../views/orks/OauthTab.vue"),
      },

      {
        path: "/SoftList",
        name: "SoftList",
        component: () => import("../views/aboutOur/SoftList.vue"),
      },

      {
        path: "/HonorsList",
        name: "HonorsList",
        component: () => import("../views/aboutOur/HonorsList.vue"),
      },

      {
        path: "/TimeLine",
        name: "TimeLine",
        component: () => import("../views/aboutOur/TimeLine.vue"),
      },

     

      {
        path: "/ourBanner",
        name: "ourBanner",
        component: () => import("../views/aboutOur/BannerList.vue"),
      },

      {
        path: "/WhyChoose",
        name: "WhyChoose",
        component: () => import("../views/banner/WhyChoose.vue"),
      },

      {
        path: "/ProductAdvantages",
        name: "ProductAdvantages",
        component: () => import("../views/orks/ProductAdvantages.vue"),
      },

      {
        path: "/CulturalConcept",
        name: "CulturalConcept",
        component: () => import("../views/aboutOur/CulturalConcept.vue"),
      },

      {
        path: "/NewsTop",
        name: "NewsTop",
        component: () => import("../views/news/NewsTop.vue"),
      },
      {
        path: "/ServicesTop",
        name: "ServicesTop",
        component: () => import("../views/services/ServicesTop.vue"),
      },
      {
        path: "/serviceslist",
        name: "serviceslist",
        component: () => import("../views/services/ServicesList.vue"),
      },
      {
        path: "/addserviceslist",
        name: "addserviceslist",
        component: () => import("../views/services/AddServicesList.vue"), // 子路由的组件
      },
      {
        path: "/servicesclassify",
        name: "servicesclassify",
        component: () => import("../views/services/ServicesClassify.vue"),
      },
      {
        path: "/tinymce-test",
        name: "tinymceTest",
        component: () => import("../components/TinyMCETest.vue"),
      }, 
    ],
  },
 {
    path: "/oauth",
    name: "oauth",
    redirect: "",
    component: () => import("../views/orks/OauthTab.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
